import React from 'react';
import {Link} from 'react-router-dom';
import './Hero.css';
import company from '../config/company';
import hero720 from '../assets/images/hero-720.webp';
import hero1200 from '../assets/images/hero-1200.webp';

const Hero = () => (
  <section className="hero" aria-labelledby="hero-title">
    <div className="hero__inner">
      <div className="hero__text">
        <p className="kicker">Ambulanter Pflegedienst in Eitorf</p>
        <h1 id="hero-title" className="hero__title">
          Ambulante Pflege in Eitorf, die Sie wirklich entlastet.
        </h1>
        <p className="hero__lead">
          Behandlungs- und Grundpflege, Wundmanagement, Palliativbegleitung und Pflegeberatung
          durch examinierte Fachkräfte. Persönlich, verlässlich und direkt mit allen Kassen
          abgerechnet.
        </p>
        <div className="hero__actions">
          <Link className="btn btn--primary" to="/kontakt">Kostenlos beraten lassen</Link>
          <Link className="btn btn--ghost" to="/leistungen">Unsere Leistungen</Link>
        </div>
        <p className="hero__phone">
          Oder direkt anrufen:{' '}
          <a href={`tel:${company.phoneIntl}`}>{company.phone}</a>
          <span className="hero__hours">{company.openingHours.label}</span>
        </p>
      </div>

      <div className="hero__media">
        <img
          src={hero1200}
          srcSet={`${hero720} 720w, ${hero1200} 1200w`}
          sizes="(max-width: 900px) 88vw, 500px"
          width="1200"
          height="1500"
          alt="Das Team von Cura Care in Eitorf"
          fetchPriority="high"
          decoding="async"
        />
        <div className="hero__badge">
          <strong>24h-Rufbereitschaft</strong>
          <span>Tag und Nacht erreichbar</span>
        </div>
      </div>
    </div>
  </section>
);

export default Hero;
